const REQUIREMENT = Object.freeze({
    0: {
        id: 0,
        key: 'required',
        label_key: 'metrics_admin_panel.requirement_enum.required'
    },
    1: {
        id: 1,
        key: 'required_qualitative',
        label_key: 'metrics_admin_panel.requirement_enum.required_qualitative'
    },
    2: {
        id: 2,
        key: 'required_quantitative',
        label_key: 'metrics_admin_panel.requirement_enum.required_quantitative'
    },
    3: {
        id: 3,
        key: 'expected',
        label_key: 'metrics_admin_panel.requirement_enum.expected'
    },
    4: {
        id: 4,
        key: 'recommended',
        label_key: 'metrics_admin_panel.requirement_enum.recommended'
    },
});

export {
    REQUIREMENT
};